const actions = {

    SPL_STORE_SUMMARY_DATA_BEGIN : 'SPL_STORE_SUMMARY_DATA_BEGIN',
    SPL_STORE_SUMMARY_DATA_SUCCESS: 'SPL_STORE_SUMMARY_DATA_SUCCESS',
    SPL_STORE_SUMMARY_DATA_ERR : 'SPL_STORE_SUMMARY_DATA_ERR',

    GATE_MEETING_VIDEO_START_BEGIN : 'GATE_MEETING_VIDEO_START_BEGIN',
    GATE_MEETING_VIDEO_START_SUCCESS: 'GATE_MEETING_VIDEO_START_SUCCESS',
    GATE_MEETING_VIDEO_START_ERR : 'GATE_MEETING_VIDEO_START_ERR',
    GATE_MEETING_VIDEO_START_RESET : 'GATE_MEETING_VIDEO_START_RESET',

    GATE_MEETING_VIDEO_CHUNK_BEGIN : 'GATE_MEETING_VIDEO_CHUNK_BEGIN',
    GATE_MEETING_VIDEO_CHUNK_SUCCESS: 'GATE_MEETING_VIDEO_CHUNK_SUCCESS',
    GATE_MEETING_VIDEO_CHUNK_ERR : 'GATE_MEETING_VIDEO_CHUNK_ERR',
    GATE_MEETING_VIDEO_CHUNK_RESET : 'GATE_MEETING_VIDEO_CHUNK_RESET',

    GATE_MEETING_VIDEO_COMPLETE_BEGIN : 'GATE_MEETING_VIDEO_COMPLETE_BEGIN',
    GATE_MEETING_VIDEO_COMPLETE_SUCCESS: 'GATE_MEETING_VIDEO_COMPLETE_SUCCESS',
    GATE_MEETING_VIDEO_COMPLETE_ERR : 'GATE_MEETING_VIDEO_COMPLETE_ERR',
    GATE_MEETING_VIDEO_COMPLETE_RESET : 'GATE_MEETING_VIDEO_COMPLETE_RESET',

    GATE_MEETING_SUBMIT_BEGIN : 'GATE_MEETING_SUBMIT_BEGIN',
    GATE_MEETING_SUBMIT_SUCCESS: 'GATE_MEETING_SUBMIT_SUCCESS',
    GATE_MEETING_SUBMIT_ERR : 'GATE_MEETING_SUBMIT_ERR',
    GATE_MEETING_SUBMIT_RESET : 'GATE_MEETING_SUBMIT_RESET',

    getSplStoreSummaryDataBegin: () => {
        return {
            type: actions.SPL_STORE_SUMMARY_DATA_BEGIN,
        };
    },

    getSplStoreSummaryDataSuccess: (data) => {
        return {
            type: actions.SPL_STORE_SUMMARY_DATA_SUCCESS,
            data,
        };
    },

    getSplStoreSummaryDataErr: (err) => {
        return {
            type: actions.SPL_STORE_SUMMARY_DATA_ERR,
            err,
        };
    },

    gateMeetingVideoStartBegin: () => {
        return {
            type: actions.GATE_MEETING_VIDEO_START_BEGIN,
        };
    },

    gateMeetingVideoStartSuccess: (data) => {
        return {
            type: actions.GATE_MEETING_VIDEO_START_SUCCESS,
            data,
        };
    },

    gateMeetingVideoStartErr: (err) => {
        return {
            type: actions.GATE_MEETING_VIDEO_START_ERR,
            err,
        };
    },

    gateMeetingVideoStartReset: () => {
        return {
            type: actions.GATE_MEETING_VIDEO_START_RESET,
        };
    },

    gateMeetingVideoChunkBegin: () => {
        return {
            type: actions.GATE_MEETING_VIDEO_CHUNK_BEGIN,
        };
    },

    gateMeetingVideoChunkSuccess: (data) => {
        return {
            type: actions.GATE_MEETING_VIDEO_CHUNK_SUCCESS,
            data,
        };
    },

    gateMeetingVideoChunkErr: (err) => {
        return {
            type: actions.GATE_MEETING_VIDEO_CHUNK_ERR,
            err,
        };
    },

    gateMeetingVideoChunkReset: () => {
        return {
            type: actions.GATE_MEETING_VIDEO_CHUNK_RESET,
        };
    },

    gateMeetingVideoCompleteBegin: () => {
        return {
            type: actions.GATE_MEETING_VIDEO_COMPLETE_BEGIN,
        };
    },

    gateMeetingVideoCompleteSuccess: (data) => {
        return {
            type: actions.GATE_MEETING_VIDEO_COMPLETE_SUCCESS,
            data,
        };
    },

    gateMeetingVideoCompleteErr: (err) => {
        return {
            type: actions.GATE_MEETING_VIDEO_COMPLETE_ERR,
            err,
        };
    },

    gateMeetingVideoCompleteReset: () => {
        return {
            type: actions.GATE_MEETING_VIDEO_COMPLETE_RESET,
        };
    },

    gateMeetingSubmitBegin: () => {
        return {
            type: actions.GATE_MEETING_SUBMIT_BEGIN,
        };
    },

    gateMeetingSubmitSuccess: (data) => {
        return {
            type: actions.GATE_MEETING_SUBMIT_SUCCESS,
            data,
        };
    },

    gateMeetingSubmitErr: (err) => {
        return {
            type: actions.GATE_MEETING_SUBMIT_ERR,
            err,
        };
    },

    gateMeetingSubmitReset: () => {
        return {
            type: actions.GATE_MEETING_SUBMIT_RESET,
        };
    },

};

export default actions;
